var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#70b246;}.cls-2{fill:#ff715d;}.cls-3{fill:#f4e211;}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flower_1",
    "data-name": "flower 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1016.58,507.77c30.92-25.68,66.81-47.46,106.66-52.69s84.06,9.12,106,42.8c21.74,33.39,17.2,79.35-4,113.1S1169,667.63,1132,682.6s-76.22,22.95-114.61,33.61-76.8,24.46-108.08,49.14c-9.73,7.68-21.14,16.95-33,13.43-29.39-8.72-6.15-42.72.86-57.8,11.47-24.67,18-51.26,30.35-75.78A431.15,431.15,0,0,1,1016.58,507.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623,529.5C704.24,628.41,748,757.37,743.65,885.27c-.58,17.27-2,34.69.76,51.75s10.26,34.14,24.18,44.4c23.58,17.39,59,9.38,80.07-11S879.23,920.63,885.2,892c23.28-111.77,2.64-232.09-56.57-329.71-17.93-29.56-40.21-57.92-70.8-74s-71-17.36-97.8,4.45a71.1,71.1,0,0,0-25.85,54.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M473.77,190.92c-32.35-14.7-72.7-16.54-101.76,3.91s-39.71,66.52-16,93c11.45,12.8,28.18,19.2,43.36,27.25s30.41,19.73,33.85,36.57c3.23,15.84-5.25,32.2-17.35,42.94s-27.39,17-42.21,23.46c-40.5,17.65-80.53,38.69-111.21,70.47s-51,76-45.33,119.82,42.24,84.32,86.39,86c28.53,1.1,55.49-13,78.49-30s43.78-37.07,68.66-51.07,55.81-21.22,82.06-10c19.45,8.33,33.57,25.44,46,42.56s24.35,35.29,41.67,47.44,41.88,16.85,59.47,5.1C699.9,685,703,657.18,703.23,633s.71-51.43,18.43-67.84c12.76-11.83,31.2-14.65,48.44-17.07,45.42-6.4,91.58-14.1,132.38-35.07s76-57.52,84.33-102.64-17.28-97.18-61.63-108.93c-46.11-12.21-90.93,18.95-134.91,37.42-21.11,8.87-48.94,13.54-64-3.67-11.47-13.09-9.82-33.22-3.81-49.56S738.12,254.19,741,237c4.45-26.17-9.26-54.43-32.56-67.14s-54.48-8.95-74.08,9c-21,19.14-37.16,81-73.63,75.54-14.75-2.2-27.11-20.78-37.52-30C508.31,211.11,492,199.21,473.77,190.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 582.07,
    cy: 436.37,
    rx: 113.73,
    ry: 60.54,
    transform: "translate(-87.49 151.91) rotate(-13.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M940.23,686.31s121.07-148.59,221.51-156.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M718.27,705.22S755,802.52,744.41,937"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M894.56,770.23s2.29,124-28.85,177.94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects25);
export default __webpack_public_path__ + "static/media/objects-25.482d0207bc2f61e63bf2622175a5120f.svg";
export { ForwardRef as ReactComponent };